import { render, staticRenderFns } from "./JournalInventory.vue?vue&type=template&id=b182efea"
import script from "./JournalInventory.vue?vue&type=script&lang=js"
export * from "./JournalInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports